let root = `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/admin/v1`;

export default {
    root,

    user: {
        login() {
            return '/login';
        },
        register() {
            return '/register';
        },
        logout() {
            return '/logout';
        },
        roles() {
            return '/user/roles';
        },
        verify() {
            return '/verify-email';
        },
        forgotPassword() {
            return '/forgot-password';
        },
        resetPassword() {
            return '/reset-password';
        },
        resendEmail() {
            return '/resend-email';
        },
        getAuthUser() {
            return '/auth/user';
        },
        editAdminInfo(id) {
            return `/user/${id}`
        }
    },
    roles: {
        getRolesAndPermissions() {
            return `/roles-permissions`
        },
        getDefaultPermissions() {
            return `/permissions-default`
        },
        storeRolesAndPermissions() {
            return `/roles-permissions`
        },
    },
    overview: {
        getTotalStats() {
            return '/overview/total-stats';
        },
        getBookingsToday() {
            return '/overview/bookings-today';
        },
        getSalesByCategory() {
            return '/overview/sales-by-category';
        },
        getStatistics() {
            return '/overview/statistics';
        },
        getDailyRevenueByAdmin() {
            return `/overview/daily-revenue-by-admin`;
        }
    },
    company: {
        getCompany(id) {
            return `/company/${id}`
        },
        getCompanies() {
            return `/company`
        },
        createCompany() {
            return '/company'
        },
        updateSubscription(id) {
            return `/company/${id}/subscription`
        }
    },
    services: {
        createService() {
            return '/service'
        },
        getServices() {
            return '/service'
        },
        editService(id) {
            return `/service/${id}`
        },
        deleteService(id) {
            return `/service/${id}`
        },
        getServicesGroupedByCategories() {
            return `/service/grouped-by-categories`
        }
    },
    bookings: {
        getBookings() {
            return `/booking`
        },
        getSimpleBookings() {
            return `/booking/simple`
        },
        exportBookings() {
            return `/booking/export`
        },
        createBooking() {
            return `/booking`
        },
        updateBooking(id) {
            return `/booking/${id}`
        },
        changeDuration(id) {
            return `/booking/${id}/change-duration`
        },
        updateStatus(id) {
            return `/booking/${id}/status`
        },
        payBooking(id) {
            return `/booking/${id}/pay`
        },
        deleteBooking(id) {
            return `/booking/${id}`
        },
        getBookingHistory(id) {
            return `/booking/${id}/history`
        }
    },
    events: {
        getEvents() {
            return '/events'
        },
        createEvent() {
            return `/events`
        },
        updateEvent(id) {
            return `/events/${id}`
        },
        deleteEvent(id) {
            return `/events/${id}`
        },
        types: {
            getEventTypes() {
                return '/event-types'
            },
            createEventType() {
                return '/event-types'
            }
        }
    },
    eventSessions: {
        getEventSessions() {
            return '/event-sessions'
        },
        createEventSession() {
            return `/event-sessions`
        },
        updateEventSession(id) {
            return `/event-sessions/${id}`
        },
        deleteEventSession(id) {
            return `/event-sessions/${id}`
        },
        getSessionUsers(id) {
            return `/event-sessions/${id}/participants`
        }
    },
    speakers: {
        getSpeakers() {
            return '/event-leads'
        },
        createSpeaker() {
            return `/event-leads`
        },
        updateSpeaker(id) {
            return `/event-leads/${id}`
        },
        deleteSpeaker(id) {
            return `/event-leads/${id}`
        },
    },
    categories: {
        getCategories() {
            return '/category'
        },
        createCategory() {
            return '/category'
        },
        editCategory(id) {
            return `/category/${id}`
        },
        deleteCategory(id) {
            return `/category/${id}`
        }
    },
    locations: {
        getLocations() {
            return '/location'
        },
        getLocationById(id) {
            return `/location/${id}`
        },
        createLocation() {
            return '/location'
        },
        editLocation(id) {
            return `/location/${id}`
        },
        deleteLocation(id) {
            return `/location/${id}`
        },
        toggleActive() {
            return `/location/toggle-active`
        },
        downloadQR(id) {
            return `/location/${id}/qr-code`
        }
    },
    staff: {
        getStaff() {
            return '/staff'
        },
        getStaffById(id) {
            return `/user/${id}`
        },
        getWholeStaff() {
            return `/whole-staff`
        },
        createStaff() {
            return '/staff'
        },
        editStaff(id) {
            return `/staff/${id}`
        },
        sendInvitation(id) {
            return `/staff/invite/${id}`
        },
        deleteStaff(id) {
            return `/staff/${id}`
        },
        downloadTipsQR(id) {
            return `/staff/${id}/leave-tips-qr`
        }
    },
    tips: {
        getTips() {
            return '/tips'
        },
        getTipConfigs() {
            return '/tip-configs'
        },
        setTipConfig() {
            return `/tip-configs`
        },
        requestPayout(id) {
            return `/tips/${id}/request-payout`
        },
        payoutPreview(id) {
            return `/tips/${id}/payout-preview`
        },
    },
    admin: {
        getAdmins() {
            return '/admins'
        },
    },
    ratingReviews: {
        getAverageRating() {
            return `/ratings/average`
        },
        getRatingReviews() {
            return `/ratings`
        },
        deleteReview(id) {
            return `/ratings/${id}`
        },
    },
    salary: {
        getSalary() {
            return '/salary-templates'
        },
        getSalaryReports() {
            return '/salary-reports'
        },
        exportSalaryReport(id) {
            return `/salary-reports/${id}/export`
        },
        exportSalaryReports() {
            return `/salary-reports/export`
        },
        markSalaryReportPaid() {
            return '/salary-reports/mark-paid'
        },
        createSalary() {
            return '/salary-templates'
        },
        deleteSalary(id) {
            return `/salary-templates/${id}`
        },
        getSalaryTemplateById(id) {
            return `/salary-templates/${id}`
        },
        getSalaryTemplateStaff() {
            return `/salary-templates/staff`
        },
        getDailySalary() {
            return `/salary-reports/daily`
        },
        payDailySalaryReport() {
            return '/salary-reports/daily/pay'
        },
        editSalary(id) {
            return `/salary-templates/${id}`
        }
    },
    customers: {
        getCustomers() {
            return '/customer'
        },
        getCustomerBookings(id) {
            return `/customer/${id}/bookings`
        },
        getCustomerEvents(id) {
            return `/customer/${id}/events`
        },
        getCustomerSales(id) {
            return `/customer/${id}/sales`
        },
        deleteCustomer(id) {
            return `/customer/${id}`
        },
        editCustomer(id) {
            return `/customer/${id}`
        },
        sendGroupMessage() {
            return `/customer/send-message`
        }
    },
    credits: {
        storeCredit() {
            return '/credits'
        },
        getCreditHistory(id) {
            return `/credits/${id}/history`
        },
    },
    integrations: {
        getIntegrations() {
            return `/integration`
        },
        updateIntegrations() {
            return `/integration`
        },
        deleteIntegration(id) {
            return `/integration/${id}`
        },
    },
    messageHelp: {
        setupMessageHelp() {
            return `/message-help/setup`
        },
        createMessageHelpAccount() {
            return `/message-help`
        },
        getMessageHelpStatus() {
            return `/message-help`
        },
        getActiveToken() {
            return `/message-help/active-token`
        },
    },
    impersonate: {
        companyAuth() {
            return `/impersonate`
        }
    },
    modules: {
        getModules() {
            return `/modules`
        },
        getSingleModule(name) {
            return `/modules/${name}`
        },
        updateModules() {
            return `/modules`
        }
    },
    settings: {
        getSettings() {
            return `/settings`
        },
        updateSettings() {
            return `/settings`
        }
    },
    userSettings: {
        getSettings(id) {
            return `/user-settings/${id}`
        },
        updateSettings() {
            return `/user-settings`
        }
    },
    paymentSettings: {
        getPaymentSettings() {
            return `/payment-settings`
        },
        updatePaymentSettings() {
            return `/payment-settings`
        }
    },
    payments: {
        getPayments() {
            return '/payments'
        },
        refundPayment(id) {
            return `/payments/refund/${id}`
        },
        updatePayment(id) {
            return `/payments/${id}`
        },
        findPayment(id) {
            return `/payments/${id}`
        },
    },
    storages: {
        getStorages() {
            return '/storages'
        },
        getStorageHistory(id) {
            return `/storages/${id}/history`
        },
        updateStorage(id) {
            return `/storages/${id}`
        },
        createStorage() {
            return `/storages`
        },
        deleteStorage(id) {
            return `/storages/${id}`
        },
        increaseProducts(id) {
            return `/storages/${id}/increase-products`
        },
        decreaseProducts(id) {
            return `/storages/${id}/decrease-products`
        },
        detachProducts(storageId, productId) {
            return `/storages/${storageId}/products/${productId}`
        },
    },
    products: {
        getProducts() {
            return '/products'
        },
        getProductsOptions() {
            return '/products'
        },
        downloadExample() {
            return '/products/example/export'
        },
        importProducts() {
            return '/products/import'
        },
        deleteProduct(id) {
            return `/products/${id}`
        },
        createProduct() {
            return '/products'
        },
        updateProduct(id) {
            return `/products/${id}`
        },
        getProductHistory(id) {
            return `/products/${id}/history`
        }
    },
    templates: {
        getTemplates() {
            return '/packages'
        },
        createTemplate() {
            return `/packages`
        },
        updateTemplate(id) {
            return `/packages/${id}`
        },
        deleteTemplate(id) {
            return `/packages/${id}`
        }
    },
    sales: {
        getSales() {
            return '/sales'
        },
        getSaleById(id) {
            return `/sales/${id}`
        },
        getSalesStatistics() {
            return '/get-sales-statistics'
        },
        createSale() {
            return `/sales`
        },
        refundSale(id) {
            return `/sales/${id}`
        },
        exportSaleInvoice(id) {
            return `/sales/${id}/export-invoice`
        }
    },
    notificationTemplates: {
        getTemplate(template) {
            return `/notification-templates/${template}`
        },
        createTemplate() {
            return `/notification-templates`
        },
    },
    coupons: {
        getCoupons() {
            return '/coupons'
        },
        createCoupon() {
            return `/coupons`
        },
        updateCoupon(id) {
            return `/coupons/${id}`
        },
        deleteCoupon(id) {
            return `/coupons/${id}`
        },
        getCouponHistory(id) {
            return `/coupons/${id}/history`
        }
    },
    discounts: {
        getDiscounts() {
            return '/discounts'
        },
        createDiscount() {
            return `/discounts`
        },
        updateDiscount(id) {
            return `/discounts/${id}`
        },
        deleteDiscount(id) {
            return `/discounts/${id}`
        }
    },
    giftCards: {
        getGiftCards() {
            return '/gift-cards'
        },
        getSingleGiftCard(id) {
            return `/gift-cards/${id}`
        },
        updateGiftCard(id) {
            return `/gift-cards/${id}`
        },
        createGiftCard() {
            return `/gift-cards`
        },
        deleteGiftCard(id) {
            return `/gift-cards/${id}`
        }
    },
    giftCardPurchases: {
        getGiftCardPurchases() {
            return '/gift-card-purchases'
        },
        createGiftCardPurchase() {
            return `/gift-card-purchases`
        },
        getSingleGiftCardPurchase(id) {
            return `/gift-card-purchases/${id}`
        },
    },
    statistics: {
        getBookingsStatistics() {
            return '/statistics/booking'
        },
    },
    notifications: {
        getNotifications() {
            return '/notifications'
        },
        markAllAsRead() {
            return '/notifications/mark-as-read'
        },
        markAsRead(id) {
            return `/notifications/${id}/mark-as-read`
        },
    },
    payouts: {
        getPayouts() {
            return '/payouts'
        },
        updatePayout(id) {
            return `/payouts/${id}`
        },
    },
    updateIndex: {
        updateIndex() {
            return `/service/update-indexes`
        }
    },
    gallery: {
        getGalleryImages() {
            return `/gallery`
        },
        createGalleryImage() {
            return `/gallery`
        },
        deleteGalleryImage(id) {
            return `/gallery/${id}`
        }
    },
    widgetSettings: {
        getSettings(id) {
            return `/widget-settings/${id}`
        },
        updateSettings() {
            return `/widget-settings`
        }
    },
    certification: {
        getCertifications() {
            return `/certification`
        },
        createCertification() {
            return `/certification`
        },
        deleteCertification(id) {
            return `/certification/${id}`
        }
    },
    resources: {
        getResources() {
            return '/resource';
        },
        createResource() {
            return '/resource';
        },
        editResource(id) {
            return `/resource/${id}`;
        },
        deleteResource(id) {
            return `/resource/${id}`;
        }
    },
    schedule: {
        createStaffSchedule() {
            return '/schedule/staff';
        }
    },
    desks: {
        getDesks() {
            return '/desks';
        },
        getDeskById(id) {
            return `/desks/${id}`;
        },
        getDesksDashboard() {
            return '/desks-dashboard';
        },
        createDesk() {
            return '/desks';
        },
        updateDesk(id) {
            return `/desks/${id}`;
        },
        deleteDesk(id) {
            return `/desks/${id}`;
        },
        getDeskTransactions() {
            return '/desk-transactions';
        },
        createDeskTransaction() {
            return '/desk-transactions';
        },
        updateDeskTransaction(id) {
            return `/desk-transactions/${id}`;
        },
        getDeskTransaction(id) {
            return `/desk-transactions/${id}`;
        },
        deleteDeskTransaction(id) {
            return `/desk-transactions/${id}`;
        },
        transferBetweenDesks() {
            return '/desk-transactions/transfer';
        },
        getDeskTransactionStatistics() {
            return '/desk-transactions-statistics';
        }
    }
}
